"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadWithWindow = exports.formatSemver = void 0;

var tslib_1 = require("tslib");

var formatSemver = function formatSemver(semver) {
  return semver.replace(/[^0-9.]/g, '');
};

exports.formatSemver = formatSemver;

var loadWithWindow = function loadWithWindow(_a) {
  var _b, _c, _d, _e;

  var scope = _a.scope,
      module = _a.module,
      dependencies = _a.dependencies,
      _f = _a.alreadyInitalised,
      alreadyInitalised = _f === void 0 ? false : _f,
      _g = _a.shareDependencies,
      shareDependencies = _g === void 0 ? {} : _g;
  var container = window === null || window === void 0 ? void 0 : window[scope];
  if (!container || !(container === null || container === void 0 ? void 0 : container.init) || !(container === null || container === void 0 ? void 0 : container.get)) return null;

  if (!alreadyInitalised) {
    // I know that this isn't a great way of doing this, I wrote a nice way in the lib/matchDependencies.ts file
    // but can't figure out how to dynamically require() modules, so until then this will work...
    // Loop through all the dependency semvers and 'clean' them
    Object.keys(dependencies).forEach(function (dependencyName) {
      dependencies[dependencyName] = (0, exports.formatSemver)(dependencies[dependencyName]);
    });
    Object.keys(shareDependencies).forEach(function (dependencyName) {
      Object.keys(shareDependencies[dependencyName]).forEach(function (dependencyVersion) {
        var _a;

        shareDependencies[dependencyName] = (_a = {}, _a[(0, exports.formatSemver)(dependencyVersion)] = shareDependencies[dependencyName][dependencyVersion], _a);
      });
    }); // Share these default dependencies over the window

    var initDeps = tslib_1.__assign({
      react: (_b = {}, _b[dependencies === null || dependencies === void 0 ? void 0 : dependencies.react] = {
        eager: true,
        singleton: true,
        get: function get() {
          return Promise.resolve().then(function () {
            return function () {
              return require('react');
            };
          });
        }
      }, _b),
      'react-dom': (_c = {}, _c[dependencies === null || dependencies === void 0 ? void 0 : dependencies['react-dom']] = {
        singleton: true,
        get: function get() {
          return Promise.resolve().then(function () {
            return function () {
              return require('react-dom');
            };
          });
        }
      }, _c),
      'styled-components': (_d = {}, _d[dependencies === null || dependencies === void 0 ? void 0 : dependencies['styled-components']] = {
        singleton: true,
        get: function get() {
          return Promise.resolve().then(function () {
            return function () {
              return require('styled-components');
            };
          });
        }
      }, _d),
      '@hopin-team/provider-translation': (_e = {}, _e[dependencies === null || dependencies === void 0 ? void 0 : dependencies['@hopin-team/provider-translation']] = {
        singleton: true,
        get: function get() {
          return Promise.resolve().then(function () {
            return function () {
              return require('@hopin-team/provider-translation');
            };
          });
        }
      }, _e)
    }, shareDependencies);

    container.init(initDeps);
  }

  return function () {
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
      return tslib_1.__generator(this, function (_a) {
        return [2
        /*return*/
        , container.get(module).then(function (factory) {
          return factory();
        }).catch(function (error) {
          return console.error('Error in mounting slice with window method', error);
        })];
      });
    });
  };
};

exports.loadWithWindow = loadWithWindow;